import { ESdChangeReason, IWFStep, IWorkFlow } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import { KuikaInputAutoSize } from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaMentions, { IKuikaMentionOption } from "../../../../ui-kit/kuika-mentions/kuika-mentions";

/** One row to start, as antd's field did, growing with what is written. */
const DESCRIPTION_ROWS: KuikaInputAutoSize = { minRows: 1, maxRows: 20 };

export interface IWorkflowStepDescriptionState {}

export interface IWorkflowStepDescriptionProps {
  wf: IWorkFlow;
  step: IWFStep;
  handleDescriptionChange: (val) => void;
}

class WorkflowStepDescription extends PureSdComponent<
  IWorkflowStepDescriptionProps & IWithSDProps & IWithContextProp,
  IWorkflowStepDescriptionState
> {
  constructor(props: IWorkflowStepDescriptionProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {};
  }

  triggerDescriptionChange = (val: string): void => {
    this.props.handleDescriptionChange(val);
  };

  getParamForDescription = (): IKuikaMentionOption[] => {
    const paramList: IKuikaMentionOption[] = [];
    const wf = this.props.wf;
    if (wf.parameters) {
      for (const param of wf.parameters) {
        paramList.push({ value: param.name, label: param.name });
      }
    }
    paramList.push({ value: "processInitiator", label: "Process Initiator" });
    // paramList.push({ value: "processInstanceId", label: "Process Instance Id" });
    // paramList.push({ value: "stepInstanceId", label: "Step Instance Id" });
    // paramList.push({ value: "assignedUser", label: "Assigned User" });

    return paramList;
  };

  render() {
    const description = _.clone(this.props.step.description);
    return (
      <>
        {/* Saved on blur, as before: a pick from the list writes into the text without taking focus
            away, so the half-typed description is never what gets stored. antd grew the field
            from one row without limit; the kit wants a ceiling, set well past a real description. */}
        <KuikaMentions
          className="kuika__workflow__textarea"
          placeholder="You can use process parameters in description simply by starting with '@'"
          defaultValue={description}
          autoSize={DESCRIPTION_ROWS}
          onBlur={(e: React.FocusEvent<HTMLTextAreaElement>): void => this.triggerDescriptionChange(e.target.value)}
          options={this.props.wf.parameters ? this.getParamForDescription() : []}
        />
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason == ESdChangeReason.SaveWorkflow || changeReason == ESdChangeReason.ClickWfDesignXmlNode)
      return true;
    return false;
  };
}

const workflowStepDescription = withContext<IWorkflowStepDescriptionProps>(
  withSD<IWorkflowStepDescriptionProps>(WorkflowStepDescription)
);
export { workflowStepDescription as WorkflowStepDescription };
